import React from 'react'
import { withRouter } from 'react-router-dom'
import WithContext from '../subComponents/WithContext/WithContext'
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidCatch(error, error_info) {
    // You can also log the error to an error reporting service
    this.props.dispatch({
      type: 'TRACK_EVENT_WITH_PATH',
      payload: {
        pathName: this.props.location.pathname,
        eventType: 'failed_to_load',
        eventProperties: { error, error_info }
      }
    })
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <>
          <h1>Whoops!</h1>
          <h1>Something went wrong.</h1>
        </>
      )
    }

    return this.props.children
  }
}

export default WithContext(withRouter(ErrorBoundary))
// export default withRouter(ErrorBoundary)
